/** Store admin info snapshot used to pre-fill the receipt step. */
export type StoreAdminInfo = Readonly<{
  storeName: string;
  legalName: string;
  rfc: string;
  fiscalAddress: string;
}>;

/**
 * Creates a StoreAdminInfo value object from raw primitives.
 *
 * Normalizes inputs and concatenates the address pieces into a single readable
 * line used as the fiscal address in the receipt form.
 *
 * @param params - Raw fields from the admin endpoint response
 * @returns Frozen StoreAdminInfo
 */
export const createStoreAdminInfo = (params: {
  storeName: string;
  legalName: string;
  rfc: string;
  street: string;
  extNumber: string;
  neighborhood: string;
  zipCode: string;
  city: string;
  state: string;
}): StoreAdminInfo => {
  const fiscalAddress = `${params.street.trim()} ${params.extNumber.trim()}, ${params.neighborhood.trim()}, ${params.zipCode.trim()} ${params.city.trim()}, ${params.state.trim()}`;

  return Object.freeze({
    storeName: params.storeName.trim(),
    legalName: params.legalName.trim(),
    rfc: params.rfc.trim().toUpperCase(),
    fiscalAddress,
  });
};
